export default "__VITE_ASSET__d821154c__"